import * as React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

export interface ForgotPasswordGridProps {
  onSubmit: (userName: string) => void,
}

export function ForgotPasswordGrid(props: ForgotPasswordGridProps) {
  const [userName, setUserName] = React.useState<string>('');

  return (
    <Grid container>
      <Grid item xs={12} component={Typography} variant='h6'>
        Reset password
      </Grid>
      <Grid item xs={12} component={Typography} variant='body2'>
        Please enter your registered email address below. An email will be sent to you with a link to reset your password.
      </Grid>
      <Grid item md={12}>
        <TextField
          required
          type='email'
          label='Email'
          value={userName}
          onChange={
            (ev) => setUserName(ev.target.value)
          }
        />
      </Grid>
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          onClick={
            () => props.onSubmit(userName)
          }
        >Submit</Button>
      </Grid>
    </Grid>
  );
}
